const MANEDER = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'] as const;

/**
 * Perioden slik den står i aksepten (DD-32) og på programsiden: «10.–24. oktober»,
 * eller med begge måneder når den krysser et månedsskifte. Samme form som SDK-et
 * bruker — ett løfte, én ordlyd.
 */
export function periode(fra: string, til: string): string {
  const f = new Date(fra);
  const t = new Date(til);
  if (Number.isNaN(f.getTime()) || Number.isNaN(t.getTime())) return '—';
  return f.getMonth() === t.getMonth() && f.getFullYear() === t.getFullYear()
    ? `${f.getDate()}.–${t.getDate()}. ${MANEDER[t.getMonth()]}`
    : `${f.getDate()}. ${MANEDER[f.getMonth()]} – ${t.getDate()}. ${MANEDER[t.getMonth()]}`;
}

/** Pseudonymet forkortet for panelet — det er et nummer, aldri et navn (K1). */
export function kortSubject(subject: string): string {
  return subject.length <= 12 ? subject : `${subject.slice(0, 8)}…${subject.slice(-3)}`;
}
